import { Entity, Column, ManyToOne, Index, PrimaryGeneratedColumn, OneToMany } from "typeorm";
import { Work, LicenseType } from ".";
import { WorkLicenseTypeDimension } from "./WorkLicenseTypeDimension";

@Entity()
@Index(["workId", "licenseTypeId"], { unique: true })
export class WorkLicenseType {
  @PrimaryGeneratedColumn() id: number;
  @Column("int") workId: number;

  @ManyToOne(type => Work)
  work: Work;

  @Column("int") licenseTypeId: number;

  @ManyToOne(type => LicenseType)
  licenseType: LicenseType;

  @OneToMany(type => WorkLicenseTypeDimension, workLicenseTypeDimension => workLicenseTypeDimension.workLicenseType)
  workLicenseTypeDimensions: WorkLicenseTypeDimension[];

  @Column("varchar", { nullable: true }) createdBy: string | null;
  @Column("datetime", { nullable: true }) createdAt: Date | null;
}
